import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./relayfield.css";
import { Relayfield } from "./pages/Relayfield";

createRoot(document.getElementById("root")!).render(
  <StrictMode><Relayfield /></StrictMode>
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}
